import styled from "styled-components";

export const StyledMediaContainer = styled.div`
    display: flex;
    gap: 40px;
    flex-wrap: wrap;
    margin: 20px 0;
    
    .custom-dots li {
        width: 10px !important;
        height: 10px !important;
    }

    .custom-dots li button:before {
        content: "•";
        font-size: 10px !important;
        color: gray !important;
    }

    .custom-dots li.slick-active button:before {
        font-size: 14px !important;
        color: black !important;
    }
    

    .slick-prev::before, .slick-next::before {
        color: black !important; /* Change this to any color you want */
        font-size: 20px !important; /* Adjust arrow size if needed */
    }
    

`;

export const StyledMediaInput = styled.span`
    margin-left : 10px;
`;

